export const CommentIcon = ({
  className,
  alt = "comment icon",
}: {
  className?: string;
  alt?: string;
}) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{alt}</title>
      <path
        d="M10.4674 13.0452C10.502 13.0194 10.544 13.0054 10.5872 13.0054H16.8325C17.3023 13.0054 17.7528 12.8188 18.085 12.4866C18.4172 12.1544 18.6038 11.7039 18.6038 11.2341V2.63067C18.6038 2.16089 18.4172 1.71036 18.085 1.37817C17.7528 1.04599 17.3023 0.859375 16.8325 0.859375H3.16827C2.69849 0.859375 2.24795 1.04599 1.91577 1.37817C1.58359 1.71036 1.39697 2.16089 1.39697 2.63067V11.2341C1.39697 12.2118 2.19051 13.0054 3.16827 13.0054H5.24463C5.35509 13.0054 5.44463 13.0949 5.44463 13.2054V16.4017C5.44463 16.5664 5.63252 16.6605 5.7644 16.5619L10.4674 13.0452Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
